var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('mypage-layout', {
    attrs: {
      "title": "적립금 내역"
    }
  }, [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "containerImmersive",
      fn: function () {
        return [_c('point-card')];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm",
    scopedSlots: _vm._u([{
      key: "containerImmersive",
      fn: function () {
        return [_c('v-data-table', _vm._b({
          staticClass: "v-data-table--default tbody-tr-cursor-pointer",
          attrs: {
            "dense": "",
            "hide-default-footer": "",
            "disable-filtering": "",
            "disable-pagination": "",
            "disable-sort": "",
            "no-data-text": "적립금 내역이 없습니다"
          },
          scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
            return header.hasOwnProperty('formatter');
          }), function (header, index) {
            return {
              key: `item.${header.value}`,
              fn: function (_ref) {
                var value = _ref.value,
                  item = _ref.item;
                return [_c('span', {
                  key: index,
                  domProps: {
                    "innerHTML": _vm._s(header.formatter.bind(item)(value))
                  }
                })];
              }
            };
          }), {
            key: `item.amount`,
            fn: function (_ref2) {
              var _value$format;
              var value = _ref2.value;
              return [_c('span', {
                class: {
                  'red--text': (value || 0) < 0
                }
              }, [_vm._v(_vm._s((value || 0) > 0 ? "+" : "") + _vm._s((value === null || value === void 0 ? void 0 : (_value$format = value.format) === null || _value$format === void 0 ? void 0 : _value$format.call(value)) || 0) + "원")])];
            }
          }], null, true)
        }, 'v-data-table', {
          headers: _vm.headers,
          items: _vm.items
        }, false)), _c('div', {
          staticClass: "pagination-wrap"
        }, [_c('v-pagination', {
          attrs: {
            "value": _vm.page,
            "length": _vm.pageCount,
            "total-visible": 11
          },
          on: {
            "input": function (page) {
              return _vm.$router.push({
                query: Object.assign({}, _vm.$route.query, {
                  page
                })
              });
            }
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }